import { rgba } from 'polished';
import styled from 'styled-components';
import Typography from '../../styles/Typography';
import { PlaceholderSize } from './enums';
import { StyledPlaceholderProps } from './types';

export const StyledPlaceholder = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.dimensions.placeholder.maxWidth};
  padding: 2rem 0;
`;

export const StyledPlaceholderDecor = styled.div<StyledPlaceholderProps>`
  border-radius: 100%;
  overflow: hidden;
  margin: 0 auto
    ${({ size = PlaceholderSize.Big }) =>
      (size === PlaceholderSize.Big && '1.75rem') ||
      (size === PlaceholderSize.Small && '1rem')};
  background: ${({ theme }) =>
    `linear-gradient(135deg, ${rgba(theme.colors.brand.yellow, 0.22)}, ${rgba(
      theme.colors.brand.yellow,
      0.06
    )})`};
  color: ${({ theme }) => theme.colors.brand.navy};
  height: ${({ theme, size = PlaceholderSize.Big }) =>
    theme.dimensions.placeholder.decorWrapper[size]};
  width: ${({ theme, size = PlaceholderSize.Big }) =>
    theme.dimensions.placeholder.decorWrapper[size]};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -8px;
    border-radius: 100%;
    border: 1px dashed ${({ theme }) => rgba(theme.colors.brand.yellow, 0.4)};
    pointer-events: none;
  }

  svg {
    height: 1em;
    width: 1em;
    fill: currentColor;
    font-size: ${({ theme, size = PlaceholderSize.Big }) =>
      theme.dimensions.placeholder.icon[size]};
  }
`;

export const StyledPlaceholderTitle = styled(
  Typography
)<StyledPlaceholderProps>`
  text-align: center;
  margin-bottom: ${({ size = PlaceholderSize.Big }) =>
    (size === PlaceholderSize.Big && '0.625rem') ||
    (size === PlaceholderSize.Small && '0.375rem')};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 700;
  font-size: ${({ size = PlaceholderSize.Big }) =>
    size === PlaceholderSize.Big ? '1.375rem' : '1.125rem'};
  letter-spacing: -0.015em;
`;

export const StyledPlaceholderDescription = styled(Typography).attrs({
  forwardedAs: 'p',
})<StyledPlaceholderProps>`
  text-align: center;
  margin-bottom: ${({ size = PlaceholderSize.Big }) =>
    (size === PlaceholderSize.Big && '1.75rem') ||
    (size === PlaceholderSize.Small && '1.25rem')};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 0.9375rem;
  line-height: 1.55;
  max-width: 22rem;
  margin-left: auto;
  margin-right: auto;
`;

export const StyledPlaceholderAction = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
